import { useTheme } from "styled-components";
import { Card } from "./styles";
import { Flex } from "../StyledComponents";
import Valoration from "../Valoration";
import Start from "./components/Start";
import Difficulty from "./components/Difficulty";
import Typography from "../Typography";
import Icon from "../Icon";
import InformationCircleIcon from "../../assets/icons/icon-cool/filled/InformationCircle.svg";
import { CourseInDto, LabLevel } from "../../types/course.dto";
import CourseImage from "../CourseImage";
import { useEffect, useState } from "react";

interface ComponentProps {
  course: CourseInDto;
  levels: LabLevel[]
}

const Component = ({ course, levels }: ComponentProps) => {
  const theme = useTheme() as { [key: string]: { [key: string]: string } };
  const [level, getLevel] = useState<string>('')

  useEffect(() => {
    getLevel(levels.find((level: LabLevel): string => level.id === course.level).level);
  }, [])

  return (
    <Card to={`/dashboard/cursos/${course?.id}`} >
      <Flex gap={16} justify="space-between">
        <CourseImage courseId={course.id} imageId={course.image_id || null} />
        <Flex gap={8} column>
          <Flex justify="space-between" align="center">
            <Typography as="h5" size="sm">
              {course?.title}
            </Typography>
            <Valoration value={course?.avg_rating} />
          </Flex>
          <Typography as="p" size="xs">
            {course?.description}
          </Typography>
          <Flex gap={5} align="flex-end">
            <Flex column gap={3}>
              <Flex align="center" gap={5}>
                {
                  course?.enrollment_requirement === "Mandatory" ?
                    <>
                      <Typography as="p" size="xs">
                        Obligatorio
                      </Typography>
                      <Icon
                        icon={InformationCircleIcon}
                        size="12px"
                        color={theme.colors.Warning}
                      />
                    </>
                    :
                    <Typography as="p" size="xs">
                      Opcional
                    </Typography>
                }
              </Flex>
              <Difficulty value={level} />
            </Flex>
            <Start />
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
};

export default Component;
